import ItemRow from '../components/ItemRow';
import ItemActionButton from '../components/ItemActionButton';
import Paginated from '../components/Paginated';
import BackButton from '../components/BackButton';
import useAuth from '../contexts/useAuth';
import type { ListData } from '../../../types';

const History = () => {
  const { user } = useAuth();
  const isAdmin = user?.isAdmin;

  return (
    <div className="page">
      <p className="section-title" style={{ marginTop: '20px' }}>
        History
      </p>
      <BackButton />
      <div style={{ marginTop: '20px' }}>
        <Paginated<ListData>
          route="/api/history"
          render={(item) => (
            <div
              key={`history-${item.id}`}
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                paddingRight: '10px',
              }}
            >
              <div style={{ flex: 1, minWidth: 0 }}>
                <ItemRow data={item} isAdmin={isAdmin} />
              </div>
              <ItemActionButton item={item} />
            </div>
          )}
          emptyMessage="No history yet"
        />
      </div>
    </div>
  );
};

export default History;
